import { render, staticRenderFns } from "./VideoCards.vue?vue&type=template&id=b20bb0ce&"
import script from "./VideoCards.vue?vue&type=script&lang=js&"
export * from "./VideoCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports